module.exports = __webpack_public_path__ + "img/popheader_icon.f743fe46.png";